import { SidePanelType, useSidePanel } from "PFApp/stores/side_panels_store";
import { Button } from "PFComponents/button";
import { Inline } from "PFComponents/containers";
import { LoadingDots } from "PFComponents/loading_dots";
import SidePanel from "PFComponents/side_panel/side_panel";
import { useActivity } from "PFCore/hooks/queries/activity";
import { useTranslation } from "react-i18next";

import { SuggestedWMSidePanelContent } from "./suggested_wm_side_panel_content";
import {
  SuggestedWmSidePanelData,
  useSuggestedWmSidePanelActions
} from "./use_suggested_wm_side_panel_actions";

const SuggestedWMSidePanelContainer = () => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles.suggestedWmSidePanel" });
  const { t: commonT } = useTranslation();
  const { index, isClosing, data } = useSidePanel<SuggestedWmSidePanelData>(SidePanelType.SuggestedWm);
  const { closeSuggestedWmSidePanel } = useSuggestedWmSidePanelActions();

  const { data: activity, isLoading } = useActivity(data.activityId);

  return (
    <SidePanel
      show
      zIndex={index}
      isSidePanelClosing={isClosing}
      onClose={closeSuggestedWmSidePanel}
      title={activity?.name}
      subTitle={t("title")}
      size="medium"
      qaId="ManageRoles.SuggestedWmSidePanel"
      footerRenderer={({ onSidePanelClose }) => (
        <Inline reverse>
          <Button onClick={onSidePanelClose} qaId="ManageRoles.SuggestedWmSidePanel.DoneButton">
            {commonT("done")}
          </Button>
        </Inline>
      )}
    >
      {isLoading && <LoadingDots circlesEnabled centered />}
      {activity && <SuggestedWMSidePanelContent activity={activity} />}
    </SidePanel>
  );
};

export const SuggestedWMSidePanel = () => {
  const { isOpen } = useSidePanel<SuggestedWmSidePanelData>(SidePanelType.SuggestedWm);

  if (!isOpen) {
    return null;
  }

  return <SuggestedWMSidePanelContainer />;
};
